// Fix for old grid vs. bootstrap v5. Could be deleted when grid is updated.
// Attribute data-toggle has been renamed to data-bs-toggle
$(document).ready(
    function () {
        $('[data-toggle="dropdown"]').each(function () {
            this.setAttribute('data-bs-toggle', 'dropdown');
            this.removeAttribute('data-toggle', 'dropdown');
        })
    }
);
